export default __webpack_public_path__ + "static/media/T340MANC1.e2039ce2.pdf";